// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PSVt","title":"styles_title__3VOMN"};